import { http } from './config'

export default {
  getAllLoads: () => {
    return http.get('sequence_loads')
  },
  sequenceLoad: (loadID) => {
    return http.post('sequence_load/?load_id=' + loadID)
  },
  resetSequence: (loadID) => {
    return http.post('reset_sequence/?load_id=' + loadID)
  },
  refuseLoad: (loadID) => {
    return http.post('refuse_load/?load_id=' + loadID)
  },
  getFilteredLoads: (params) => {
    return http.get('sequence_loads', {params})
  },
  finishLoadByOperator: (loadId) => {
    return http.post('loads/finish_load_by_operator/' + loadId)
  },
  getLastDeliveryDate: (localityId) => {
    return http.get('loads/last_delivery_date/?locality_id=' + localityId)
  },
  finishAllLoadsByOperator: (deliveryDate, localityId) => {
    return http.post('loads/finish_all_loads_by_operator/?delivery_date=' + deliveryDate + '&locality_id=' + localityId)
  }
}
